// extracted by mini-css-extract-plugin
module.exports = {"h1b7l17f":"h1b7l17f","tab556b":"tab556b","name":"name"};